import { defineComponent } from 'vue';
import DropdownItemComponent from '@/components/DropdownItem/DropdownItemComponent.vue';
export default defineComponent({
    name: 'DropdownItem',
    components: { DropdownItemComponent },
    data() {
        return {};
    }
});
